// extracted by mini-css-extract-plugin
export default {"cls1":"CenteredDiv-cls1_SZo","cls2":"CenteredDiv-cls2_DYN CenteredDiv-cls1_SZo"};